import { account } from './account';
import { bag } from './bag';
import { challenges } from './challenges';
import { checkout } from './checkout';
import { date } from './date';
import { delivery } from './delivery';
import { dietaryRestrictions } from './dietary-restrictions';
import { errors } from './errors';
import { footer } from './footer';
import { forcedAppUpdate } from './forced-app-update';
import { forgotPassword } from './forgot-password';
import { form } from './form';
import { general } from './general';
import { home } from './home';
import { join } from './join';
import { joinVerification } from './join-verification';
import { location } from './location';
import { login } from './login';
import { menu } from './menu';
import { menuCollection } from './menu-collection';
import { navbar } from './navbar';
import { notFoundView } from './not-found-view';
import { orderProduct } from './order-product';
import { orderStatus } from './order-status';
import { orderStatusInfo } from './order-status-info';
import { personalData } from './personal-data';
import { product } from './product';
import { rateOrder } from './rate-order';
import { reorder } from './reorder';
import { signedOutView } from './signed-out-view';
import { sweetpass } from './sweetpass';
import { sweetpassMembership } from './sweetpass-membership';

export const enUs = {
  ...general,
  ...date,
  ...account,
  ...bag,
  ...checkout,
  ...delivery,
  ...home,
  ...menu,
  ...menuCollection,
  ...location,
  ...login,
  ...join,
  ...product,
  ...personalData,
  ...challenges,
  ...navbar,
  ...errors,
  ...footer,
  ...form,
  ...dietaryRestrictions,
  ...forgotPassword,
  ...joinVerification,
  ...orderStatus,
  ...orderStatusInfo,
  ...rateOrder,
  ...reorder,
  ...sweetpass,
  ...sweetpassMembership,
  ...notFoundView,
  ...signedOutView,
  ...orderProduct,
  ...forcedAppUpdate,
};

// We only need the keys from en-US since we
// are making the assumption that all languages
// will be using the same keys in this early
// naive implementation
export type TranslationKeys = keyof typeof enUs;
